module.exports = __webpack_public_path__ + "static/media/08.e4bcf2c2.png";